import { Fragment } from "react";

/** Codice di gara che può andare a capo dopo i trattini bassi (OA1000_SIGLA_data), senza alterare il testo copiato. */
export function Codice({ value }: { value?: string }) {
  if (!value) return <>—</>;
  return (
    <>
      {value.split("_").map((parte, i) => (
        <Fragment key={i}>
          {i > 0 && (
            <>
              _<wbr />
            </>
          )}
          {parte}
        </Fragment>
      ))}
    </>
  );
}
